<div class="app-main__inner">

    <div class="app-page-title">
      <div class="page-title-wrapper">
        <div class="page-title-heading">
          <div class="page-title-icon">
            <i class="pe-7s-users icon-gradient bg-mean-fruit"></i>
          </div>
          <div>
            Client Onboarding
            <div class="page-title-subheading">
              Connect new clients to the WhatsApp Business Platform via Meta Embedded Signup.
            </div>
          </div>
        </div>
        <div class="page-title-actions">
          <button class="btn btn-primary" (click)="openAddModal()">
            <i class="fa fa-plus me-1"></i> Add New Client
          </button>
        </div>
      </div>
    </div>

    <div *ngIf="errorMessage" class="alert alert-danger alert-dismissible">
      {{ errorMessage }}
      <button type="button" class="btn-close" (click)="errorMessage = ''"></button>
    </div>

    <div *ngIf="isLoading" class="text-center py-5">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading…</span>
      </div>
    </div>

    <div *ngIf="!isLoading" class="card main-card mb-3">
      <div class="card-header">Onboarded Clients</div>
      <div class="card-body p-0">
        <div class="table-responsive">
          <table class="table table-hover mb-0">
            <thead class="table-light">
              <tr>
                <th>Client Code</th>
                <th>Verified Name</th>
                <th>Phone Number</th>
                <th>Phone No ID</th>
                <th>WABA ID</th>
                <th>DB Name</th>
                <th>Onboarded</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let client of clients">
                <td><strong>{{ client.clientCode }}</strong></td>
                <td>{{ client.verifiedName || '—' }}</td>
                <td>{{ client.displayPhoneNumber || '—' }}</td>
                <td><small class="text-muted font-monospace">{{ client.phoneNoId }}</small></td>
                <td><small class="text-muted font-monospace">{{ client.wabaId }}</small></td>
                <td><small class="font-monospace text-muted">{{ client.dbName }}</small></td>
                <td><small>{{ client.onboardedAt | date:'mediumDate' }}</small></td>
                <td>
                  <span class="badge" [ngClass]="client.isActive ? 'bg-success' : 'bg-secondary'">
                    {{ client.isActive ? 'Active' : 'Inactive' }}
                  </span>
                </td>
                <td>
                  <button
                    class="btn btn-sm"
                    [ngClass]="client.isActive ? 'btn-outline-danger' : 'btn-outline-success'"
                    (click)="toggleClientStatus(client)"
                  >
                    {{ client.isActive ? 'Deactivate' : 'Activate' }}
                  </button>
                </td>
              </tr>
              <tr *ngIf="clients.length === 0">
                <td colspan="9" class="text-center text-muted py-4">
                  No clients onboarded yet. Click <strong>Add New Client</strong> to get started.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

</div>

<!-- Add Client Modal -->
<div class="modal fade" tabindex="-1" #addClientModal>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">

      <div class="modal-header">
        <h5 class="modal-title">
          <i class="pe-7s-users me-2"></i>
          <ng-container [ngSwitch]="onboardingStep">
            <span *ngSwitchCase="'done'">Client Onboarded!</span>
            <span *ngSwitchCase="'confirm'">Review & Confirm</span>
            <span *ngSwitchDefault>Add New Client</span>
          </ng-container>
        </h5>
        <button type="button" class="btn-close" (click)="closeModal()"></button>
      </div>

      <div class="modal-body">

        <!-- Step 1: Form -->
        <div *ngIf="onboardingStep === 'form'">
          <p class="text-muted small mb-3">
            Enter the client details, then click <strong>Connect via Meta</strong> to launch the
            WhatsApp Business signup popup.
          </p>

          <div class="mb-3">
            <label class="form-label fw-semibold">
              Client Code <span class="text-danger">*</span>
            </label>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="newClientCode"
              placeholder="e.g. ACME"
              maxlength="50"
            />
            <div class="form-text">Unique identifier for this client (e.g. company abbreviation).</div>
          </div>

          <div class="mb-3">
            <label class="form-label fw-semibold">
              Database Name <span class="text-danger">*</span>
            </label>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="newDbName"
              placeholder="e.g. acme_db"
              maxlength="50"
            />
            <div class="form-text">MongoDB database name for this client's data.</div>
          </div>

          <div *ngIf="formError" class="alert alert-danger py-2 small">{{ formError }}</div>

          <button
            class="btn btn-success w-100 mt-1"
            (click)="launchMetaSignup()"
            [disabled]="!fbInitialized"
            [title]="!fbInitialized ? 'Meta SDK is loading…' : ''"
          >
            <span *ngIf="!fbInitialized" class="spinner-border spinner-border-sm me-2" role="status"></span>
            <i *ngIf="fbInitialized" class="fa fa-whatsapp me-2"></i>
            {{ fbInitialized ? 'Connect via Meta Embedded Signup' : 'Loading Meta SDK…' }}
          </button>
        </div>

        <!-- Step 2: Waiting for Meta popup -->
        <div *ngIf="onboardingStep === 'meta-pending'" class="text-center py-4">
          <div class="spinner-border text-success mb-3" role="status"></div>
          <p class="mb-1 fw-semibold">Waiting for Meta popup…</p>
          <p class="text-muted small">Complete the WhatsApp Business signup in the popup window.</p>
          <button class="btn btn-outline-secondary btn-sm mt-2" (click)="onboardingStep = 'form'">
            Cancel
          </button>
        </div>

        <!-- Step 3: Confirm -->
        <div *ngIf="onboardingStep === 'confirm'">
          <div class="alert alert-success py-2 small mb-3">
            <i class="fa fa-check-circle me-1"></i> Meta authorization successful. Review and confirm.
          </div>

          <table class="table table-sm table-bordered mb-3">
            <tbody>
              <tr>
                <td class="fw-semibold text-nowrap" width="40%">Client Code</td>
                <td>{{ newClientCode }}</td>
              </tr>
              <tr>
                <td class="fw-semibold">Database Name</td>
                <td><code>{{ newDbName }}</code></td>
              </tr>
              <tr>
                <td class="fw-semibold">WABA ID</td>
                <td>
                  <input
                    type="text"
                    class="form-control form-control-sm font-monospace"
                    [(ngModel)]="capturedWabaId"
                    placeholder="Enter WABA ID manually if empty"
                  />
                </td>
              </tr>
              <tr>
                <td class="fw-semibold">Phone Number ID</td>
                <td>
                  <input
                    type="text"
                    class="form-control form-control-sm font-monospace"
                    [(ngModel)]="capturedPhoneNoId"
                    placeholder="Enter Phone Number ID manually if empty"
                  />
                </td>
              </tr>
            </tbody>
          </table>

          <div *ngIf="!capturedWabaId || !capturedPhoneNoId" class="alert alert-warning py-2 small">
            WABA ID or Phone Number ID was not captured from Meta. Please enter them manually above.
          </div>

          <div *ngIf="formError" class="alert alert-danger py-2 small">{{ formError }}</div>

          <div class="d-flex gap-2 mt-2">
            <button
              class="btn btn-outline-secondary flex-grow-1"
              (click)="onboardingStep = 'form'"
              [disabled]="isSaving"
            >
              Back
            </button>
            <button
              class="btn btn-primary flex-grow-1"
              (click)="confirmAndSave()"
              [disabled]="isSaving || !capturedWabaId || !capturedPhoneNoId"
            >
              <span *ngIf="isSaving" class="spinner-border spinner-border-sm me-1" role="status"></span>
              {{ isSaving ? 'Saving…' : 'Confirm & Save' }}
            </button>
          </div>
        </div>

        <!-- Step 4: Done -->
        <div *ngIf="onboardingStep === 'done'" class="text-center py-3">
          <div class="text-success mb-2" style="font-size: 3.5rem;">
            <i class="pe-7s-check"></i>
          </div>
          <h5 class="mb-1">{{ newClientCode }} is now onboarded!</h5>
          <p class="text-muted small mb-0">
            <strong>Phone:</strong> {{ confirmedPhone || capturedPhoneNoId }}
          </p>
          <p class="text-muted small" *ngIf="confirmedName">
            <strong>Verified Name:</strong> {{ confirmedName }}
          </p>
          <button class="btn btn-primary mt-3" (click)="closeModal()">Done</button>
        </div>

      </div>
    </div>
  </div>
</div>
